export default __webpack_public_path__ + "static/media/domaining.bfc32deb.png";